import { Badge } from './ui/badge';
import { getIconByName } from '@/lib/icons';
import type { BookmarkWithTags, CollectionWithCount } from '@/types/database';

interface BookmarkDragOverlayProps {
  bookmark: BookmarkWithTags;
}

export function BookmarkDragOverlay({ bookmark }: BookmarkDragOverlayProps) {
  return (
    <div className="w-64 rounded-lg border-2 border-primary bg-card p-3 shadow-xl">
      <div className="flex items-center gap-2">
        {bookmark.favicon_url && (
          <img src={bookmark.favicon_url} alt="" className="h-4 w-4 rounded-sm" />
        )}
        <span className="truncate text-sm font-medium">{bookmark.title}</span>
      </div>
      <p className="mt-1 truncate text-xs text-muted-foreground">{bookmark.domain}</p>
    </div>
  );
}

interface CollectionDragOverlayProps {
  collection: CollectionWithCount;
}

export function CollectionDragOverlay({ collection }: CollectionDragOverlayProps) {
  const IconComponent = getIconByName(collection.icon || 'folder');

  return (
    <div className="flex items-center gap-2 rounded-md border-2 border-primary bg-card px-3 py-2 shadow-xl">
      <div style={{ color: collection.color || '#0F766E' }}>
        <IconComponent className="h-4 w-4" />
      </div>
      <span className="text-sm font-medium">{collection.name}</span>
      <Badge variant="secondary" className="ml-auto">
        {collection.bookmark_count}
      </Badge>
    </div>
  );
}
